import store from '../../br/stores/mobile';
import { MOBAGE_PC, UPDATE_USER_INFO } from '../store/web/h5';
import globalConfig from '../utiles/globalConfig';
import { getJSON, getHrefParam } from '../store/ultile';
import { GET_MOBAGE_PRODUCT_INFO, SUBMIT_PAY_TYPE } from '../store/web/h5';

const FROM_MOBAGE = !!globalConfig.getHrefParam('fromMobage');
const isMobagePc = !!globalConfig.getHrefParam('mobagePC');
// const hasState = !!globalConfig.getHrefParam("state");
// const stateValue = globalConfig.getHrefParam("state");
const isPlanB = false;
const loginAccount = decodeURIComponent(
  globalConfig.getHrefParam('loginAccount')
);
const userId = decodeURIComponent(globalConfig.getHrefParam('uid'));
// const isAuth = globalConfig.getHrefParam("auth") === "true";

let getLoginHrefURL = `//jppassport.37games.com/web_mobage_login/mobage_auth`;
let MOBAGE_SESSION_STATE = '';
export let IS_GO_LOGIN = false;
let STATE_VALUE = '';

export const showMobageTips = FROM_MOBAGE;
export const SET_MOBAGE_STATE = (val) => {
  MOBAGE_SESSION_STATE = val;
};

const postMessgeToParent = (data) => {
  if (window.parent === window) {
    return;
  }
  window.parent &&
    window.parent.postMessage &&
    typeof window.parent.postMessage === 'function' &&
    window.parent.postMessage(data, '*');
};

const judgeMobageLoginStatus = () => {
  if (!isPlanB) {
    return Promise.resolve();
  }
  return new Promise((resolve, reject) => {
    let params = {
      state: STATE_VALUE,
      responseType: ['code', 'token']
    };
    let cb = function(error) {
      if (error) {
        if (!error.login) {
          reject();
        }
      }
      resolve();
    };
    mobage.oauth.getConnectedStatus(params, cb);
  });
};

const getLoginStatus = async () => {
  let params = {
    game_id: window.gameId,
    cid: getHrefParam('cid') || '250',
    scid: getHrefParam('scid') || 'web'
  };
  let { errmsg, data, res } = await getJSON(getLoginHrefURL, params);
  if (errmsg) {
    alert(errmsg);
  }
  if (data.url) {
    window.location.href = res.data.url;
  }
};

export const uploadEnterGame = (data) => {
  data = Object.assign({}, data, { type: 'enterGame' });
  postMessgeToParent(data);
};

export const uploadCreateRole = (data) => {
  data = Object.assign({}, data, { type: 'createRole' });
  postMessgeToParent(data);
};

export const beforeEach = async (to, from, next) => {
  let userData = {};
  if (isMobagePc) {
    userData = {
      LOGIN_ACCOUNT: loginAccount,
      UID: userId
    };
    store.commit(UPDATE_USER_INFO, userData);
  }
  if (FROM_MOBAGE && isMobagePc) {
    next();
  } else {
    IS_GO_LOGIN = true;
    next({ path: '/nbpf', replace: true });
  }
};

export default {
  data() {
    return {
      IS_TEST_ENV: window.envObj[window.gameId] === 'test'
    };
  },
  created() {
    if (!isPlanB && FROM_MOBAGE && !isMobagePc) {
      if (window.mobageReady) {
        this.initMobageSessionListener();
      } else {
        document.addEventListener('mobageReady', () => {
          this.initMobageSessionListener();
        });
      }
    }
  },
  methods: {
    openThirdPlatformUserCenter(type) {
      if (isMobagePc) {
        let isTestEnv = window.envObj[this.gameId] === 'test';
        let mobageGameId = +this.gameId === 2 ? '12026808' : '12026897';
        // window.open(`http://sb.yahoo-mbga.jp/game/${mobageGameId}/detail?fourth`, "_blank") // 沙盒审核链接
        window.open(
          `http://${
            isTestEnv ? 'sb.' : ''
          }yahoo-mbga.jp/game/${mobageGameId}/detail?fourth`,
          '_blank'
        ); // 正式环境链接
        return;
      }
      if (type === 'service') {
        mobage.ui.show('inquiry');
      }
    },
    openCommercialLaw(type) {
      if (isMobagePc) {
        let isTestEnv = window.envObj[this.gameId] === 'test';
        let mobageGameId = +this.gameId === 2 ? '12026808' : '12026897';
        // window.open(`http://sb.yahoo-mbga.jp/game/${mobageGameId}/detail?third`, "_blank") // 沙盒审核链接
        window.open(
          `http://${
            isTestEnv ? 'sb.' : ''
          }yahoo-mbga.jp/game/${mobageGameId}/detail?third`,
          '_blank'
        ); // 正式环境链接
        return;
      }
      if (type === 'commercial_transaction') {
        mobage.ui.show('commercial_transaction');
      }
    },
    openSettingChange(type) {
      if (isMobagePc) {
        // window.open("http://sb.yahoo-mbga.jp/config/mygame", "_blank") // 沙盒审核链接
        window.open('http://yahoo-mbga.jp/config/mygame', '_blank'); // 正式环境链接
        return;
      }
      if (type === 'client_configuration') {
        mobage.ui.open(
          'client_configuration',
          {
            requiredMessage: 1,
            requiredMygame: 1
          },
          function(error, result) {
            // handle callback
            console.log(result);
          }
        );
      }
    },
    openVoucherNotes() {
      let url = 'http://sp.mbga.jp/voucher/notes.html';
      if (isMobagePc) {
        url = 'http://yahoo-mbga.jp/page/kiyaku/voucher.html';
      }
      window.open(url, '_blank'); // 正式环境链接
    },
    openMobacoinTerms() {
      let url = 'http://sp.mbga.jp/payment/coin/kiyaku';
      if (isMobagePc) {
        url = 'http://yahoo-mbga.jp/page/kiyaku/voucher.html';
      }
      window.open(url, '_blank'); // 正式环境链接
    },
    openYahooTerms() {
      window.open('http://yahoo-mbga.jp/page/kiyaku/', '_blank');
    },
    openMembershipAgreement() {
      window.open('http://sp.mbga.jp/kiyaku/', '_blank');
    },
    openMobageRule() {
      let url = 'http://sp.mbga.jp/rule/';
      if (isMobagePc) {
        url = 'http://yahoo-mbga.jp/page/rule/';
      }
      window.open(url, '_blank'); // 正式环境链接
    },
    thirdPlatformHandleUserBehave(sdkParam) {
      if (sdkParam.type === 'commercial law') {
        this.openCommercialLaw('commercial_transaction');
      }
      if (sdkParam.type === 'setting_change') {
        this.openSettingChange('client_configuration');
      }
      if (sdkParam.type === 'voucher_notes') {
        this.openVoucherNotes();
      }
      if (sdkParam.type === 'mobacoin_terms') {
        this.openMobacoinTerms();
      }
      if (sdkParam.type === 'yahoo_terms') {
        this.openYahooTerms();
      }
      if (sdkParam.type === 'membership_agreement') {
        this.openMembershipAgreement();
      }
      if (sdkParam.type === 'mobage_rule') {
        this.openMobageRule();
      }
    },
    thirdPlatformPay(sdkParam) {
      if (FROM_MOBAGE && !isMobagePc) {
        this.refreshMobageLoginStatus(sdkParam);
      } else {
        this.getMobageSkuInfo(sdkParam);
      }
    },
    getMobageSkuInfo(params) {
      const skuURL = '//jpstore.37games.com/mobage_pc/product_info';
      getJSON(skuURL, { game_id: this.gameId, product_id: params.productId })
        .then((res) => {
          if (res.errmsg) {
            alert(res.errmsg);
            return;
          }
          let data = res.data;
          postMessgeToParent({
            gameId: this.gameId,
            serverId: params.serverId,
            roleId: params.roleId,
            roleName: params.roleName,
            skuId: +data.SKU_ID,
            price: +data.TRANS_AMOUNT,
            productName: data.PRODUCT_DESC,
            productImg: `${window.location.origin}/mobage/${params.productId}.png`,
            amount: +data.TRANS_AMOUNT,
            cpProductId: params.cpProductId,
            remark: params.remark,
            type: 'pay'
          });
        })
        .catch((err) => {
          alert(err.errmsg || err.msg || err);
        });
    },
    initMobageSessionListener() {
      // console.log(MOBAGE_SESSION_STATE);
      mobage.event.subscribe(
        'oauth.sessionStateChange',
        MOBAGE_SESSION_STATE,
        (result) => {
          if (result === 'changed') {
            window.onbeforeunload = false;
            setTimeout(() => {
              window.location.href =
                '//jppassport.37games.com/web_mobage_login/mobageLogout/game_id/' +
                window.gameId;
            });
          }
        }
      );
    },
    async refreshMobageLoginStatus(sdkParam) {
      let refresSuccess = await this.refreshMobageToken();
      if (refresSuccess) {
        this.fetchProductInfo(sdkParam);
      }
    },
    async refreshMobageToken() {
      return new Promise((resolve, reject) => {
        const url = '//jppassport.37games.com/web_mobage_login/observe_token';
        getJSON(url, { game_id: this.gameId })
          .then((res) => {
            if (res.errmsg) {
              alert(res.errmsg);
              resolve(false);
              return;
            }
            resolve(true);
          })
          .catch((err) => {
            resolve(false);
          });
      });
    },
    async fetchProductInfo(params) {
      this.sdkParam = params;
      let list = await this.$store.dispatch(GET_MOBAGE_PRODUCT_INFO, params);
      let curProduct = list.find(
        (item) => item.PRODUCT_ID === params.productId
      );
      if (!curProduct) {
        alert('Error');
        return;
      }
      this.mobagePay(curProduct);
    },
    mobagePay(productInfo) {
      try {
        globalConfig.statistics('submit_pay', {
          pid: this.sdkParam.productId,
          pay_type: 'mobage'
        });
      } catch (e) {}
      const mainHost = '//jpstore.37games.com/';
      let url = mainHost + 'mobage_nbpf/submit';
      if (this.IS_TEST_ENV) {
        url += '/env/test';
      }
      let params = {
        gameId: parseInt(this.gameId, 10),
        serverId: this.sdkParam.serverId,
        roleName: encodeURIComponent(this.sdkParam.roleName),
        roleId: this.sdkParam.roleId,
        paytype: 'mobage_nbpf',
        productId: this.sdkParam.productId,
        amount: productInfo.TRANS_AMOUNT,
        remark: this.sdkParam.remark || this.sdkParam.price || '',
        cpProductId: this.sdkParam.cpProductId,
        currency: productInfo.CURRENCY,
        devicePlate: window.isPhone ? 'wap' : 'pc',
        is_sdk_view: '',
        language: 'jp',
        location: 'JP',
        productDesc: (productInfo.PRODUCT_NAME || '').replace(/.*(?:\=)/, ''),
        isJMH5: 1,
        packageName: 'com.jp.beauty.mobage',
        ...window.globalGetLinkParams()
      };
      this.collectData({ event: 'click', ext1: '确认储值信息，并提单' });
      this.$store
        .dispatch(SUBMIT_PAY_TYPE, { url, params })
        .then((response) => {
          const res = response.data;
          if (+res.result !== 1) {
            // this.isDMMFailTips = true;
            // this.faileTipsText = res.msg;
            this.collectData({ event: 'open', ext1: '储值失败，展示失败页面' });
            alert(res.msg);
          } else {
            // this.closePopup();
            // this.excMobagePay(res)
            if (window.mobageReady) {
              this.excMobagePay(res.data);
            } else {
              document.addEventListener('mobageReady', () => {
                this.excMobagePay(res.data);
              });
            }
          }
        })
        .catch(() => {
          alert('failed to initialize payment procedures.');
        });
    },
    excMobagePay(order) {
      judgeMobageLoginStatus()
        .then(() => {
          this.widget = mobage.ui.open(
            'payment',
            {
              transactionId: order.transaction_id,
              orderId: order.order_id
            },
            (error, result) => {
              if (error) {
                // Request GameServer to update OrderDB status.
                // The status on OrderDB should be updated from authorized to canceled/error.
                this.cancelMobagePay(order);
                return;
              }
              this.fulfillItemOrder(result.response, result.signedResponse);
            }
          );
        })
        .catch(() => {
          getLoginStatus();
        });
    },
    cancelMobagePay(order) {
      const mainHost = '//jpstore.37games.com/';
      let url =
        mainHost +
        `mobage_nbpf/cancel${this.IS_TEST_ENV ? '/env/test' : ''}/game_id/` +
        this.gameId;
      this.$store
        .dispatch(SUBMIT_PAY_TYPE, { url, params: order })
        .then((response) => {
          // Clear transaction from Client Storage.
          mobage.bank.clearPaymentBacklog(order.transaction_id);
        })
        .catch((err) => {});
    },
    fulfillItemOrder(response, signedResponse) {
      const mainHost = '//jpstore.37games.com/';
      let url =
        mainHost +
        `mobage_nbpf/online_callback${
          this.IS_TEST_ENV ? '/env/test' : ''
        }/game_id/` +
        this.gameId;
      this.$store
        .dispatch(SUBMIT_PAY_TYPE, {
          url,
          params: signedResponse,
          notStringify: true
        })
        .then((res) => {
          res = res.data;
          if (+res.result !== 1) {
            alert('アイテム付与処理に失敗しました');
            return;
          }
          mobage.bank.clearPaymentBacklog(response.result.payment.id);
        })
        .catch((err) => {});
    }
  }
};
